import { Injectable } from "@angular/core";

import { DataService } from "../../shared/services/data.service";
import { BaseService } from "../../shared/services/base.service";
import { ConstantsService } from "../../shared/services/constants.service";
import { MasterscreenConstantsService } from "../services/masterscreen-constants.service";

@Injectable()
export class MasterscreenService {
  isAppAdminLoggedIn = false;

  constructor(
    private dataService: DataService,
    private baseService: BaseService
  ) { }

  public updatedActionData: any;
  public getUpdatedData(actionType) {
  switch (actionType) {
  //   case 'ActionParty':
  //     return this.updatedPartyData;
   //   case 'ActionOwner':
  //     return this.updatedOwnerData;
  //   case 'ActionVerifier':
  //     return this.updatedVerifierData;
          case 'UpdateAction':
           
            if (this.updatedActionData)
                return this.updatedActionData;
              else 
                return "{}";
      }
   }
   public setUpdatedData(data, actionType) {
    switch (actionType) {
 // case 'ActionParty':
//   this.updatedPartyData = data;
//   break;
 // case 'ActionOwner':
 //   this.updatedOwnerData = data;
//   break;
// case 'ActionVerifier':
//   this.updatedVerifierData = data;
 //   break;
 case 'UpdateAction':
  this.updatedActionData = data;
  break;
  
 }
   }
  
   public oldPTWCertificates: any;
   public getOldPTWCertificates(actionType) {
   switch (actionType) {
           case 'oldPTWCertificates':
            
             if (this.oldPTWCertificates)
                 return this.oldPTWCertificates;
               else 
                 return "{}";
       }
    }
    public setOldPTWCertificates(data, actionType) {
     switch (actionType) {

      case 'oldPTWCertificates':
      this.oldPTWCertificates = data;
      break;
   }
  }

  public oldPTWgasTestRecords: any;
   public getoldPTWgasTestRecords(actionType) {
   switch (actionType) {
           case 'PTWgasTestRecords':
            
             if (this.oldPTWgasTestRecords)
                 return this.oldPTWgasTestRecords;
               else 
                 return "{}"; 
                  
       }
    }
    public setoldPTWgasTestRecords(data, actionType) {
     switch (actionType) {

      case 'PTWgasTestRecords':
      this.oldPTWgasTestRecords = data;
      break;
   }
  }
  
  public oldPTWOAFRecords: any;
   public getoldPTWOAFRecords(actionType) {

    if (this.oldPTWOAFRecords)
        return this.oldPTWOAFRecords;
      else 
        return "{}"; 
    
    }
    public setoldPTWOAFRecords(data, actionType) {

      this.oldPTWOAFRecords = data;
  }

  public oldPTWAuthorizationData: any;
   public getoldPTWAuthorizationData(actionType) {

    if (this.oldPTWAuthorizationData)
        return this.oldPTWAuthorizationData;
      else 
        return ""; 
    
    }
    public setoldPTWAuthorizationData(data, actionType) {

      this.oldPTWAuthorizationData = data;
  }

  public oldPTWTRICTableRecords: any;
   public getoldPTWTRICTableRecords(actionType) {

    if (this.oldPTWTRICTableRecords)
        return this.oldPTWTRICTableRecords;
      else 
        return "{}"; 
    
    }
    public setoldPTWTRICTableRecords(data, actionType) {

      this.oldPTWTRICTableRecords = data;
  }

  public oldPTWSafetyRecords: any;
  public getoldPTWSafetyRecords(actionType) {

   if (this.oldPTWSafetyRecords)
       return this.oldPTWSafetyRecords;
     else 
       return "{}"; 
   
   }
   public setoldPTWSafetyRecords(data, actionType) {

     this.oldPTWSafetyRecords = data;
   }

   public oldPTWValidationRecords: any;
   public getoldPTWValidationRecords(actionType) {

   if (this.oldPTWValidationRecords)
       return this.oldPTWValidationRecords;
     else 
       return "{}"; 
   
   }
   public setoldPTWValidationRecords(data, actionType) {

     this.oldPTWValidationRecords = data;
   }

   public oldPTWAcceptanceRecords: any;
   public getoldPTWAcceptanceRecords(actionType) {

   if (this.oldPTWAcceptanceRecords)
       return this.oldPTWAcceptanceRecords;
     else 
       return "{}"; 
   
   }
   public setoldPTWAcceptanceRecords(data, actionType) {

     this.oldPTWAcceptanceRecords = data;
   }

   public oldPTWSuspensionRecords: any;
   public getoldPTWSuspensionRecords(actionType) {

   if (this.oldPTWSuspensionRecords)
       return this.oldPTWSuspensionRecords;
     else 
       return "{}";   
   }
   public setoldPTWSuspensionRecords(data, actionType) {
     this.oldPTWSuspensionRecords = data;
   }

  /**
   * Function to Save Company Details request.
   * @param model - Model contain Status
   * @param response - response of request.
   */
  saveCompanyDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveCompanyDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  savePrerequisitesDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.savePrerequisiteDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  SavePrerequisiteConfiguration(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.savePrerequisiteConfiguration,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  RetriveListOfPrerequisiteConfigurationMapping(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL
          .RetriveListOfPrerequisiteConfigurationMapping,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Project Details request.
   * @param model - Model contain Project details
   * @param response - response of request.
   */
  saveProjectDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveProjectDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Location Details request.
   * @param model - Model contain Status
   * @param response - response of request.
   */
  saveLocationDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveLocationDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Section request.
   * @param model - Model contain Status
   * @param response - response of request.
   */
  saveSectionDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveSectionDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Configuration Details request.
   * @param model - Model contain configuration details
   * @param response - response of request.
   */
  saveConfigurationDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveConfigurationDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  /**
   * Function to Get Company Details
   * @param model - Model contain Status
   * @param callbackMethod - return the response
   */
  getSectionDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getSectionDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  /**
   * Function to Get Company Details
   * @param model - Model contain Status
   * @param callbackMethod - return the response
   */
  getCompanyDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getCompanyDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  /**
   * Function to Get Company Details
   * @param model - Model contain Status
   * @param callbackMethod - return the response
   */
  getPermissionsDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getPermissionsDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  savePermissionForRoleId(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.RolePermission, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPermissionForRoleId(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetRolePermissions, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get Company Details
   * @param model - Model contain Status
   * @param callbackMethod - return the response
   */
  getRoleMasterDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetRoleMasterDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  saveRoleMaster(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.RoleMaster, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  /**
   * Function to get Project Details request.
   * @param response - response of request.
   */
  getProjectDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getProjectDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
/**
   * Function to Save KPI Master
   * @param model - Model contain api request
   * @param response - response of request.
   */

  saveKPIMaster(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveKPIMaster, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  /**
   * Function to Get All KPI Master.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getKPIMasterList(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getKPIMasterList, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get All Location Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getLocationDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getLocationDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  /**
   * Function to Get All Location Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getPrerequisiteDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getPrerequisiteDetails, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  /**
   * Function to Save Contractor Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  saveContractorDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveContractorDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Hazard Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  saveHazardDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveHazardDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get All contractor Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getUserDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getUserDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get All contractor Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  sendContractorDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.forgetPassword, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to delete contractor Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  deleteContractorDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.deleteContractorDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to delete hazard Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  deleteHazardDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.deleteHazardDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get Hazard Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getHazardDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getHazardDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save observation type Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  saveObservationTypeDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.saveObservationTypeDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save observation category Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  saveObservationCategoryDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.saveObservationCategoryDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get Observation type Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getObservationTypeDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.getObservationTypeDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get Observation category Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getObservationCategoryDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.getObservationCategoryDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to delete observation type Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  deleteObservationTypeDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.deleteObservationTypeDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to delete observation category Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  deleteObservationCategoryDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.deleteObservationCategoryDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to get the status of Observation configuration wizard.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getIsObservationConfigurationCompleted(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL
          .getIsObservationConfigurationCompleted,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to check the role for app admin
   */
  checkAppAdminDetails() {
    const permissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    
     if (!permissions.APP_Admin &&(!permissions.HSE_Admin) &&(!permissions.SUPER_Admin)) {//Pritesh
       this.baseService.navigateToUrl(ConstantsService.URL.HOMEPAGE);
     }
  }

  /**
   * Function to check the no of role assigned to user
   * @param model - Model contain api request
   * @param response - response of request.
   */
  checkNoOfRoleAssignedToUser(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.getNoOfRoleAssignedToUser,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Save Role mapping
   * @param model - Model contain api request
   * @param response - response of request.
   */
  saveUserRoleMapping(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveUserRoleMapping, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to get User role mapping details
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getUserRoleMappingDetails(callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getUserRoleMappingDetails)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to delete User Role Mapping Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  deleteUserRoleMappingDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.deleteUserRoleMappingDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to get raise request of user id
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getRaiseRequestCountForUserId(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.getRaiseRequestCountForUserId,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to save Source Configuration Details request.
   * @param model - Model contain model request
   * @param response - response of request.
   */
  saveSourceConfigurationDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.saveSourceConfigurationDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  /**
   * Function to Get All Source Configuration Details.
   * @param model - Model contain api request
   * @param response - response of request.
   */
  getSourceConfigurationDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.getSourceConfigurationDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

  saveUserActivityDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveUserActivityDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getTreeData(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetTreeDataForUser, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getAllTreeData(model, callbackMethod) {
    
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetAllTreeData, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }



  getEmployeesForUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetEmployeesForUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getUnitTypes(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetUnitTypes, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SaveUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteUnitContactInfo(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeleteUnitContactInfo, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteContractDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.DeleteUnitContractDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getContractDetailsForUnit(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetContractDetailsForUnit,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  deactivateUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeActivateUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  savePermissionMatrixData(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SavePermissionMatrixData, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPermissionMatrixDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetPermissionMatrixData, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getUnits(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetUnits, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getIsActiveUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getIsActiveUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getCountForDashboard(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetDashboardCount, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getDashboardSelectedDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetDashboardSelectedDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  RemoveUserFromUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.RemoveUserFromUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveInspectionChecklistConfigurationDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL
          .SaveInspectionChecklistConfigurationDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getCheckLists(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetCheckLists, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getAllModules(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetAllModules, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveCategoryData(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SaveCategoryData, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveCategoryRule(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SaveCategoryRule, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getCategoryDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetCategoryDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getCategoryRule(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetCategoryRule, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveLifeSavingMappingDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.SaveLifeSavingMappingDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getLifeSavingMappingDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetLifeSavingMappingDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  savePassTypeDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.savePassTypeDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPassTypeDetailsData(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getPassTypeDetailsData, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPassTypeCategory(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getPassTypeCategory, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  savePassTypeCategoryMapping(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.savePassTypeCategoryMapping,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPassTypeCategoryMapping(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetPassTypeCategoryMapping,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  retriveOfPassTypeCategoryDataForChecked(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL
          .RetriveOfPassTypeCategoryDataForChecked,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getAllMonitoringMatrixName(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetAllMonitoringMatrixName,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  saveMatrixDetails(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.SaveMonitoringMatrixDetails,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteCheckListPoint(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeleteCheckListPoint, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  savePDF(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SavePDF, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getcategoryMappingDetailsByModuleId(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetCategoryMappingDetailsByModuleId,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPassTypeDetailsDataForConfiguration(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL
          .GetPassTypeDetailsDataForConfiguration,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getDictionaryJSON(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetDictionaryJSON, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  setDictionaryJSON(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SetDictionaryJSON, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteCheckList(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeleteCheckList, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getPermissionsForOverview(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetPermissionsForOverview,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getDataForCategoryOverview(model, callbackMethod) {
    this.dataService
      .post(
        MasterscreenConstantsService.APIURL.GetDataForCategoryOverview,
        model
      )
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  SaveProcessDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.SaveProcessDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  updateUnitTree(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.UpdateUnitTree, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteUnit(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeleteUnit, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  deleteSection(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.DeleteSection, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getCheckListDetails(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetCheckListDetails, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  getCheckListNames(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.GetCheckListNames, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }

  saveEmailConfiguration(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveEmailConfiguration, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getEmailConfiguration(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getEmailConfiguration, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getEmailReceiverType(model, callbackMethod) {
     
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getEmailReceiverType, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getContractDetailsData(model, callbackMethod) {
    return this.dataService.post(MasterscreenConstantsService.APIURL.GetContractDetailsData, model)
    .subscribe(
      response => callbackMethod(response.Result)
    );
  }

  saveRiskManagementTool(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveRiskManagementTool, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getRiskManagementTool(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getRiskManagementTool, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }
  
  saveRiskApprovalLevel(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.saveRiskApprovalLevel, model)
      .subscribe((response) => {
        callbackMethod(response);
      });
  }
  getRiskApprovalLevel(model, callbackMethod) {
    this.dataService
      .post(MasterscreenConstantsService.APIURL.getRiskApprovalLevel, model)
      .subscribe((response) => {
        callbackMethod(response.Result);
      });
  }

}
